(() => {
  const connectOfferLinks = () => {
    const offer = document.querySelector('[data-oeo-meta-sale][data-offer-ready="true"]');
    const code = offer?.dataset.discountCode;
    if (!code) return;
    // Category buttons/images already have server-rendered discount links.
    // Cover the dedicated landing layout's remaining shopping navigation too.
    document.querySelectorAll('.oeo-offer-brand, .oeo-offer-cart, .oeo-offer-footer-brand').forEach(link => {
      const target = new URL(link.href, location.href);
      if (target.origin !== location.origin || target.pathname.startsWith('/discount/')) return;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart\/?)?$/i.test(target.pathname)) return;
      const destination = target.pathname + target.search + target.hash;
      link.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectOfferLinks, {once: true});
  else connectOfferLinks();
  window.addEventListener('pageshow', connectOfferLinks);
  document.addEventListener('shopify:section:load', connectOfferLinks);
})();
